import React from "react";
import "./PropertyApplicationComments.css";

export default function PropertyApplicationComments({
  comments = [],
  renderActions,
}) {
  const entries = Array.isArray(comments)
    ? comments.filter(
        (item) => typeof item?.body === "string" && item.body.trim(),
      )
    : [];
  if (!entries.length) return null;
  return (
    <section
      className="property-application-comments"
      aria-label="Support comments for this application"
    >
      <h3>Support comments for this application</h3>
      {[...entries].reverse().map((comment, index) => (
        <article key={comment.id || index}>
          <div className="property-application-comment-meta">
            SmartLend Support
            {comment.created_at &&
              Number.isFinite(new Date(comment.created_at).getTime()) && (
                <time dateTime={comment.created_at}>
                  {new Date(comment.created_at).toLocaleString("en-SG", {
                    timeZone: "Asia/Singapore",
                  })}
                </time>
              )}
          </div>
          {comment.updated_at &&
            Number.isFinite(new Date(comment.updated_at).getTime()) && (
              <div className="property-application-comment-meta">
                Edited{" "}
                <time dateTime={comment.updated_at}>
                  {new Date(comment.updated_at).toLocaleString("en-SG", {
                    timeZone: "Asia/Singapore",
                  })}
                </time>
              </div>
            )}
          <div
            className="property-application-comment-body"
            role="region"
            aria-label={`Support comment ${index + 1}`}
            tabIndex={0}
          >
            {comment.body}
          </div>
          {renderActions?.(comment)}
        </article>
      ))}
    </section>
  );
}
